/* ══════════════════════════════════════════════
   NICHIBOKU NIPPORI — Theme JS
   ══════════════════════════════════════════════ */

(function() {
  'use strict';

  // Nav scroll effect
  var nav = document.getElementById('nbNav');
  if (nav) {
    window.addEventListener('scroll', function() {
      nav.classList.toggle('scrolled', window.scrollY > 50);
    });
  }

  // Hamburger menu
  var ham = document.getElementById('nbHamburger');
  var mob = document.getElementById('nbMobile');
  if (ham && mob) {
    ham.addEventListener('click', function() {
      ham.classList.toggle('active');
      mob.classList.toggle('open');
    });
    var links = mob.querySelectorAll('a');
    for (var i = 0; i < links.length; i++) {
      links[i].addEventListener('click', function() {
        ham.classList.remove('active');
        mob.classList.remove('open');
      });
    }
  }

  // Scroll reveal with IntersectionObserver
  if ('IntersectionObserver' in window) {
    var reveals = document.querySelectorAll('.nb-reveal');
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry, i) {
        if (entry.isIntersecting) {
          setTimeout(function() {
            entry.target.classList.add('visible');
          }, i * 60);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });

    for (var j = 0; j < reveals.length; j++) {
      observer.observe(reveals[j]);
    }
  } else {
    // Fallback: show all
    var els = document.querySelectorAll('.nb-reveal');
    for (var k = 0; k < els.length; k++) {
      els[k].classList.add('visible');
    }
  }
})();
